import React from 'react'
import {useTranslation} from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import {useHistory} from 'react-router-dom'

import Layout from '../layouts/centered'
import { useAppSelector } from '../redux/store'
import {LinkButton} from "../components/button";
import styled from "styled-components";

const ErrorTitle = styled.h1`
	margin-bottom: 1rem;
		
	color: var(--it-accent-blue);
	font-family: "Druk Wide";
	font-size: 64px;
	font-style: normal;
	font-weight: 500;
	line-height: 100%;
	letter-spacing: 5px;
	text-transform: uppercase;
`

const ErrorDescription = styled.div`
    margin-bottom: 2rem;
		
    color: var(--it-text-grey);
    text-align: center;
    /* Body */
    font-family: "Basis Grotesque Pro";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.42px;
`

export const ErrorPage = () => {
	const {t, i18n} = useTranslation();
	const {language: lang} = i18n;
	const dispatch = useDispatch();
	React.useEffect(() => {
		dispatch({
			type: 'SET_CONFIG_KEY',
			key: 'navbarTitle',
			value: t('page.404.title')
		})
	}, [dispatch, lang])
	const {settings} = useAppSelector()
	const { goBack } = useHistory()
	return (
		<Layout data-error-page>
			<div className="flex flex-col w-full max-w-xl text-center">
				<img
					className="object-contain w-auto"
					src="/pages/error-page/error-404.png"
					alt="svg"
				/>
				{/*<ErrorTitle>404</ErrorTitle>*/}

				<ErrorDescription>
					{t("page.404.description", {contactEmail: settings.settings_ui?.mail_address_from || ''})}
				</ErrorDescription>

				<div className="flex w-full">
					<LinkButton
						to="#"
						onClick={() => goBack()}
						className={'w-full'}
						title={t("page.404.button_goback")}
					/>
				</div>
			</div>
		</Layout>
	)
}

export default ErrorPage
